import React from 'react';

import CardContent from '@mui/material/CardContent';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { linkColor } from '../../constants/Colors';
import { screenType } from '../../constants/enum';

import type * as authType from '../../api/firebase/auth/authType';

const toAgentUrl = `/main/agent/auth/register`;
const toClientUrl = `/main/client/auth/register`;
const toPublisherUrl = `/main/publisher/auth/register`;

const textMb = {
  marginBottom: '16px'
};

const RegisterLinks: React.FC<authType.RegisterScreenProps> = (props) => {
  const { t } = useTranslation();

  let aboveUrl, aboveUserType, bottomUrl, bottomUserType;

  if (props.screenType === screenType.client) {
    aboveUrl = toAgentUrl;
    bottomUrl = toPublisherUrl;
    aboveUserType = t('type.agent');
    bottomUserType = t('type.publisher');
  } else if (props.screenType === screenType.agent) {
    aboveUrl = toClientUrl;
    bottomUrl = toPublisherUrl;
    aboveUserType = t('type.client');
    bottomUserType = t('type.publisher');
  } else {
    aboveUrl = toClientUrl;
    bottomUrl = toAgentUrl;
    aboveUserType = t('type.client');
    bottomUserType = t('type.agent');
  }

  return (
    <CardContent
      sx={{
        '&.MuiCardContent-root': {
          paddingBottom: 0
        },
        fontSize: '14px',
        padding: 0
      }}
    >
      <Typography align="center" sx={textMb} component="div">
        <Link sx={linkColor} href={aboveUrl}>
          {aboveUserType}
          {t('register.pageLink')}
        </Link>
      </Typography>
      <Typography align="center" component="div">
        <Link sx={linkColor} href={bottomUrl}>
          {bottomUserType}
          {t('register.pageLink')}
        </Link>
      </Typography>
    </CardContent>
  );
};

export default RegisterLinks;
